export default "__VITE_ASSET__CelOZtLa__"